<script lang="ts" setup>
import { computed, h, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import {
  darkTheme,
  dateRuRU,
  NButton,
  NConfigProvider,
  NIcon,
  NLayout,
  NLayoutHeader,
  NLayoutSider,
  NMenu,
  NSpace,
  NSwitch,
} from "naive-ui";
import AiIcon from "../../components/icons/admin/AiIcon.vue";
import ApiIcon from "../../components/icons/admin/ApiIcon.vue";
import KeyIcon from "../../components/icons/admin/KeyIcon.vue";
import { superadminRules } from "../../api/superadmin";
import { AdminFetcher } from "../../api/adminFetcher";
import { Key } from "naive-ui/es/menu/src/interface";
import ReportIcon from "../../components/icons/admin/ReportIcon.vue";
import ruRu from "naive-ui/es/locales/common/ruRU";

const router = useRouter();
const collapsed = ref(true);
const menuOptions = computed(() => {
  return [
    {
      label: "Отчеты и статистика",
      key: "reports",
      show: superadminRules.reports,
      icon: () => h(NIcon, null, { default: () => h(ReportIcon) }),
      children: [
        {
          label: "Статистика",
          key: "admin-statistics",
          show: superadminRules.reports,
        },
        {
          label: "Видеозвонки",
          key: "admin-calls-report",
          show: superadminRules.reports,
        },
      ],
    },
    {
      label: "Резюмирование",
      key: "ai-settings",
      icon: () => h(NIcon, null, { default: () => h(AiIcon) }),
      show: superadminRules.ai_access || superadminRules.prompts,
      children: [
        {
          label: "Настройки резюмирования",
          key: "admin-ai-settings",
          show: superadminRules.prompts,
        },
        {
          label: "Доступ компаний",
          key: "admin-ai-access",
          show: superadminRules.ai_access,
        },
      ],
    },
    {
      label: "Администрирование",
      key: "accounts",
      show: superadminRules.admins,
      icon: () => h(NIcon, null, { default: () => h(KeyIcon) }),
      children: [
        {
          label: "Администраторы",
          key: "admin-accounts",
          show: superadminRules.admins,
        },
        {
          label: "Запросы на доступ",
          key: "admin-access-requests",
          show: superadminRules.admins,
        },
        {
          label: "Настройки ролей",
          key: "admin-roles",
          show: superadminRules.admins,
        },
      ],
    },
    {
      label: "Внешние пользователи",
      key: "admin-external-users",
      show: superadminRules.external_users,
      icon: () => h(NIcon, null, { default: () => h(ApiIcon) }),
    },
  ];
});

function handleMenuClick(key: string) {
  const routes = {
    "admin-ai-settings": "/admin/ai-settings",
    "admin-ai-access": "/admin/ai-access",
    "admin-external-users": "/admin/external-users",
    "admin-accounts": "/admin/accounts",
    "admin-access-requests": "/admin/access-requests",
    "admin-roles": "/admin/roles",
    "admin-statistics": "/admin/statistics",
    "admin-calls-report": "/admin/calls-report",
  };
  const route = routes[key as keyof typeof routes] as unknown as string;
  if (route) {
    router.push(route);
  }
}
const activeMenu = computed(() => {
  const cr = router.currentRoute.value.name;
  if (cr === "admin-call-report") {
    return "admin-calls-report";
  }
  return cr;
});
const menu = ref<any>(null);
onMounted(() => {
  menu.value?.showOption(activeMenu.value);
});
const logout = async () => {
  await AdminFetcher.delete({
    path: "/superadmin/logout",
  });
  await router.push({ name: "admin-login" });
};
const isDark = ref(false);
</script>
<template>
  <NConfigProvider :theme="isDark ? darkTheme : undefined" :locale="ruRu" :date-locale="dateRuRU">
    <NSpace vertical>
      <NLayout has-sider>
        <NLayoutSider
          bordered
          collapse-mode="width"
          :collapsed-width="64"
          :width="240"
          :collapsed="collapsed"
          @collapse="collapsed = true"
          position="absolute"
          :style="{
            zIndex: 1000,
          }"
          @expand="collapsed = false"
          @mouseenter="collapsed = false"
          @mouseleave="collapsed = true"
        >
          <NMenu
            ref="menu"
            :collapsed="collapsed"
            :options="menuOptions"
            :collapsed-width="64"
            :collapsed-icon-size="24"
            :indent="24"
            :value="activeMenu as Key"
            @update:value="handleMenuClick"
          />
        </NLayoutSider>
        <NLayout
          :style="{
            paddingLeft: '64px',
            maxHeight: '100vh',
            height: '100vh',
            minHeight: '100vh',
            overflow: 'auto',
          }"
        >
          <NSpace
            :style="{
              height: '100%',
            }"
            :wrap-item="false"
            vertical
          >
            <NLayoutHeader bordered class="header">
              <div class="left">
                <slot name="header" />
              </div>
              <div class="right">
                <span>Темная тема</span>
                <NSwitch v-model:value="isDark" />
                <NButton strong secondary type="error" @click="logout">
                  Выйти
                </NButton>
              </div>
            </NLayoutHeader>
            <slot />
          </NSpace>
        </NLayout>
      </NLayout>
    </NSpace>
  </NConfigProvider>
</template>
<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 56px;
  // background: #fff;
  // box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
  // border-bottom: 1px solid #eee;
  padding: 12px;

  .left {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .right {
    display: flex;
    align-items: center;
    gap: 20px;
  }
}
</style>
